<template>
  <div class="flex flex-col items-center">
    <div
      :class="[
        'border-base-content/80 rounded w-8 h-8 flex items-center justify-center mb-1 bg-base-100 z-10',
        !memorySlot?.memory ? 'border-2' : 'border-none',
      ]"
    >
      <MateMemoryDot
        v-if="memorySlot?.memory"
        :color="memorySlot.memory?.labelColor"
      />
      <i class="iconify mingcute--unlock-line text-base-content/80" v-else />
    </div>
    <div class="mt-1 text-center text-xs min-w-20" v-if="memorySlot">
      {{ $t(`memory.ball.${memorySlot?.memory?.capacityLevel ?? "noMemory"}`) }}
    </div>
    <button
      class="btn btn-xs"
      v-else-if="idx !== 0"
      @click="handlePurchaseMemory(idx * 30)"
    >
      <CrystalIcon />
      {{ idx * 30 }} 解锁
    </button>
  </div>
</template>

<script setup lang="ts">
import { purchaseOneMateMemorySlot } from "@/apis/mate";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { MateMemorySlot } from "@/types/entity";
import { showConfirmDialog, showLoadingToast, showSuccessToast } from "vant";

const props = defineProps<{
  memorySlot?: MateMemorySlot;
  idx: number;
  mateId: number;
}>();

const emit = defineEmits<{
  (e: "reload"): void;
}>();

const modalStore = useGlobalModal();
const userStore = useGlobalUser();

const handlePurchaseMemory = async (count: number) => {
  if (modalStore.shouldOpenCrystalNotEnoughModal(count)) return;

  try {
    await showConfirmDialog({
      title: "提示",
      message: `确定花费 ${count} 水晶解锁记忆球吗？`,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    });
  } catch {
    return;
  }

  const loading = showLoadingToast(`解锁中...`);

  try {
    await purchaseOneMateMemorySlot({
      mateId: props.mateId,
    });

    loading.close();
    showSuccessToast("解锁成功");
    userStore.refresh();
    emit("reload");
  } catch {
    loading.close();
  }
};
</script>
